if (!customElements.get('image-comparison')) {
  customElements.define(
    'image-comparison',
    class ImageComparison extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('button');
        this.isHorizontal = this.dataset.direction !== 'vertical';
        this.isDragging = false;

        this.startDrag = this.onStartDrag.bind(this);
        this.drag = this.onDrag.bind(this);
        this.stopDrag = this.onStopDrag.bind(this);

        this.init();

        if (this.dataset.staticCenter === 'true') {
          this.setStaticCenter();
        } else {
          this.initVisibilityAnimation();
        }
      }

      init() {
        if (!this.button) return;

        this.buttonIcon = this.button.querySelector('span');
        this.offset = this.buttonIcon ? this.buttonIcon.offsetWidth / 2 : 20;

        if (this.buttonIcon) {
          this.buttonIcon.addEventListener('touchstart', this.startDrag, { passive: false });
          this.buttonIcon.addEventListener('mousedown', this.startDrag);
        }
      }

      setStaticCenter() {
        this.setAttribute('is-visible', '');
        this.style.setProperty('--percent', '50%');
      }

      initVisibilityAnimation() {
        var trigger = this.querySelector('.image-comparison__animation-trigger');
        var motionReduced =
          typeof window.matchMedia === 'function' &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (
          !motionReduced &&
          typeof FoxTheme !== 'undefined' &&
          FoxTheme.config &&
          !FoxTheme.config.motionReduced &&
          FoxTheme.Motion &&
          typeof FoxTheme.Motion.inView === 'function' &&
          trigger
        ) {
          FoxTheme.Motion.inView(trigger, this.animation.bind(this));
          return;
        }

        if (motionReduced) {
          this.setStaticCenter();
          return;
        }

        if (!trigger || typeof IntersectionObserver === 'undefined') {
          this.setStaticCenter();
          return;
        }

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                this.animation();
                observer.disconnect();
              }
            }, this);
          }.bind(this),
          { threshold: 0.2 }
        );

        observer.observe(trigger);
      }

      animation() {
        this.setAttribute('is-visible', '');
        this.classList.add('is-animating');
        setTimeout(function () {
          this.classList.remove('is-animating');
        }.bind(this), 1000);
      }

      onStartDrag(e) {
        if (!this.buttonIcon || !this.buttonIcon.contains(e.target)) return;

        e.preventDefault();
        e.stopPropagation();
        this.isDragging = true;
        document.body.classList.add('body-no-scrollbar');
        this.classList.add('is-dragging');

        this.onDrag(e);

        if (e.type === 'mousedown') {
          document.addEventListener('mousemove', this.drag);
          document.addEventListener('mouseup', this.stopDrag);
        } else if (e.type === 'touchstart') {
          document.addEventListener('touchmove', this.drag, { passive: false });
          document.addEventListener('touchend', this.stopDrag);
        }
      }

      onStopDrag() {
        if (!this.isDragging) return;

        this.isDragging = false;
        document.body.classList.remove('body-no-scrollbar');
        this.classList.remove('is-dragging');

        document.removeEventListener('mousemove', this.drag);
        document.removeEventListener('mouseup', this.stopDrag);
        document.removeEventListener('touchmove', this.drag);
        document.removeEventListener('touchend', this.stopDrag);
      }

      onDrag(e) {
        if (!this.isDragging) return;

        if (e.cancelable) e.preventDefault();

        var event = (e.touches && e.touches[0]) || e;
        var rect = this.getBoundingClientRect();
        var x, distance, mousePercent;

        if (this.isHorizontal) {
          x = event.clientX - rect.left;
          distance = rect.width;

          if (
            typeof FoxTheme !== 'undefined' &&
            FoxTheme.config &&
            FoxTheme.config.isRTL
          ) {
            x = distance - x;
          }

          if (this.dataset.staticCenter === 'true') {
            mousePercent = (x / distance) * 100;
            mousePercent = Math.max(0, Math.min(100, mousePercent));
            this.style.setProperty('--percent', mousePercent + '%');
            return;
          }

          x = event.pageX - this.offsetLeft;
          distance = this.clientWidth;
          if (
            typeof FoxTheme !== 'undefined' &&
            FoxTheme.config &&
            FoxTheme.config.isRTL
          ) {
            x = distance - x;
          }
        } else {
          x = event.clientY - rect.top;
          distance = rect.height;

          if (this.dataset.staticCenter === 'true') {
            mousePercent = (x / distance) * 100;
            mousePercent = Math.max(0, Math.min(100, mousePercent));
            this.style.setProperty('--percent', mousePercent + '%');
            return;
          }

          x = event.pageY - this.offsetTop;
          distance = this.clientHeight;
        }

        var max = distance - this.offset;
        var min = this.offset;
        var mouseX = Math.max(min, Math.min(x, max));
        mousePercent = (mouseX * 100) / distance;
        this.style.setProperty('--percent', mousePercent + '%');
      }
    }
  );
}
